import React, { Fragment, ReactNode, HTMLAttributes } from 'react';
import cx from 'classnames';

interface PageHeaderProps {
  children: ReactNode;
}

export const PageHeader = ({ children }: PageHeaderProps) => (
  <header className="page__header">{children}</header>
);

interface PageSidebarProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export const PageSidebar = ({ children, ...props }: PageSidebarProps) => {
  const className = cx('page__sidebar page__sidebar-v2');
  return (
    <aside className={className} {...props}>
      {children}
    </aside>
  );
};

interface PageMainProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export const PageMain = ({ children, ...props }: PageMainProps) => {
  const classes = 'page__main-v2';

  return (
    <main className={classes} {...props}>
      {children}
    </main>
  );
};

interface PageTitleProps {
  children: ReactNode;
}

export const PageTitle = ({ children }: PageTitleProps) => (
  <h1 className="page__title">{children}</h1>
);

interface PageProps {
  className?: string;
  children: ReactNode;
}

const Page = ({ className, children }: PageProps) => {
  // Handle Fragment detection more safely
  const flattenedChildren =
    React.isValidElement(children) && children.type === Fragment
      ? children.props.children
      : children;

  const childrenMap = React.Children.map(flattenedChildren, (child) =>
    React.isValidElement(child) ? child.type : null
  );
  const hasSidebar = childrenMap?.includes(PageSidebar);

  className = cx(
    'page',
    {
      'page--with-sidebar': hasSidebar,
    },
    className
  );

  return <section className={className}>{children}</section>;
};

export default Page;
